/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { goodLuckCoreEntitiesWinConditionTypeSchema } from "./winConditionTypeSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentRulebookSchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().min(1),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  timeoutMinutes: z.int().nullish(),
  pausePerTeamMinutes: z.int().nullish(),
  pausePerGameMinutes: z.int().nullish(),
  pauseBetweenGamesMinutes: z.int().nullish(),
  pauseRules: z.string().max(2000).nullish(),
  rehostRules: z.string().max(2000).nullish(),
  bannedChampionIdsJson: z.string().max(2000).nullish(),
  bannedRuneIdsJson: z.string().max(2000).nullish(),
  bannedItemIdsJson: z.string().max(2000).nullish(),
  bannedSummonerSpellIdsJson: z.string().max(500).nullish(),
  get defaultWinCondition() {
    return goodLuckCoreEntitiesWinConditionTypeSchema.optional();
  },
  attachmentUrl: z.string().max(2048).nullish(),
  attachmentFileName: z.string().max(512).nullish(),
  createdAt: z.optional(z.iso.datetime()),
  updatedAt: z.optional(z.iso.datetime()),
});
